/**
 * Where the footer's service links lead. One place, so a destination that changes is changed once
 * and the footer, the drawer and the placeholder pages cannot disagree.
 *
 * SUPPORT IS A PERSON FOR NOW. The Human named their own address on 2026-09-30 («supporto al
 * momento»), until a support mailbox exists. Replace it here when one does.
 */
export const SUPPORT_EMAIL = 'alessandro.raffa@dgbiotech.eu';

export const SUPPORT_HREF = `mailto:${SUPPORT_EMAIL}`;

/** The two service pages, both placeholders until their content is written (`src/service-pages/`). */
export const GUIDE_PATH = '/guide';
export const SERVICE_STATUS_PATH = '/status';
